module.exports = __webpack_public_path__ + "static/media/edit-pencil-icon.c561e21a.svg";